
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-scheduler/event-timeline/import-export",
      function () {
        return require("private-next-pages/x/react-scheduler/event-timeline/import-export.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-scheduler/event-timeline/import-export"])
      });
    }
  